import React from "react";
import Accordion from './HomeSection/Accordion/Accordion'
import Blog from './HomeSection/Blog/Blog'
import Card from './HomeSection/Card/Card'
import CourseCard from './HomeSection/CourseCard/CourseCard'
import Excerpts from './HomeSection/Excerpts/Excerpts'
import Footer from './HomeSection/Footer/footer'
import Hello from './HomeSection/Hello/Hello'
import Home from './HomeSection/Home/Home'
import HomeSlider from './HomeSection/HomeSlider/HomeSlider'
import Kids from './HomeSection/Kids/Kids'
import Navbar from './HomeSection/Navbar/Navbar'
import Photo from './HomeSection/Photos/Photo'
import Queries from './HomeSection/Queries/Queries'
import Slider from './HomeSection/Slider/Slider'

import Unlimitedlearning from './HomeSection/UNLIMITED LEARNING/Unlimitedlearning'
function Home1(){
    return(

        <div>
         
            <Home/>
            <Unlimitedlearning/>
            <CourseCard/>
            {/* <Card/> */}
            {/* <Accordion/> */}





{/* <Excerpts/> */}

{/* <Hello/> */}

{/* <HomeSlider/> */}
<Blog/>
<Kids/>


{/* <Queries/> */}

{/* <Slider/> */}
<Photo/>
{/* <Footer/> */}
        </div>
    )
}
export default Home1
